import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-v2',
	options: {
		userTags: ['activity'],
	},
	landing: {
		ids: ['loader-activity-f', 'age-activity-f'],
		route: {
			path: '/activity-f',
			name: 'female-activity-funnel',
		},
		overrides: [
			{
				matcher: {
					$and: {
						utm_content: /exercise|workout/,
						utm_campaign: /search|activitygs/,
					},
				},
				ids: ['creatives-exercise'],
			},
			{
				matcher: {
					$and: {
						utm_content: /excel/,
						utm_campaign: /demgen/,
					},
				},
				ids: ['creatives-demgen'],
			},
			{
				matcher: {
					lptype: 'female_funnel', // /activity-f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female', 'dynamic-age-f-18-50'],
			},
		],
	},
	funnel: {
		id: 'ob-female-activity',
		route: {
			path: '/activity-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-onboarding',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'female-activity-v2',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-activity-f',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-activity-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
